import Model from '@/dc-it/models/Model'
import Field from '@/dc-it/types/Field'

export default class Plan extends Model {
    endpoint ='plans';

    fields = [
      new Field('id', 'Código').disabled(),
      new Field('name', 'Nombre'),
    ];

    clone = () => Plan;
}
